import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, credentials);
      
      // Store token in localStorage
      localStorage.setItem('adminToken', response.data.access_token);
      localStorage.setItem('adminUsername', response.data.username);
      localStorage.setItem('adminRole', response.data.role);
      
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_rk-rotoarc-preview/artifacts/qs3pkdc4_IMG_4982.jpeg" 
            alt="RK ROTOARC" 
            className="h-16 mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-black">Admin Dashboard</h1>
          <p className="text-zinc-600 text-sm mt-2">Sign in to manage your website</p>
        </div>

        <Card className="border-2 border-zinc-200 shadow-lg">
          <CardHeader>
            <CardTitle className="text-2xl">Login</CardTitle>
            <CardDescription>Enter your credentials to access the dashboard</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="username" className="text-zinc-700">Username</Label>
                <Input
                  id="username"
                  name="username"
                  type="text"
                  value={credentials.username}
                  onChange={handleChange}
                  required
                  className="mt-1.5 border-zinc-300"
                  placeholder="Enter username"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-zinc-700">Password</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  className="mt-1.5 border-zinc-300"
                  placeholder="Enter password"
                />
              </div>

              <div className="text-sm text-zinc-600 bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                <strong>Default credentials:</strong><br />
                Username: admin<br />
                Password: rkrotoarc2015
              </div>

              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-6 text-lg"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </form>
          </CardContent>
        </Card>

        <p className="text-center text-zinc-500 text-sm mt-6">
          RK ROTOARC Admin Panel • {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
